import { projectSlice } from 'app/stores/project';
import { clonePage } from './clonePage';
import { addPageFromImageData, createFromImageData, updateMarkerFromImageData, } from './create';
import { deleteItems } from './deleteItems';
import { rasterizeProjectAction } from './rasterize';
import { gotoNextPage, gotoPrevPage, selectPage } from './selectPage';
import { setProperty } from './setProperty';
export const ProjectActions = Object.assign(Object.assign({}, projectSlice.actions), { clonePage,
    deleteItems,
    selectPage,
    gotoPrevPage,
    gotoNextPage, rasterizeProject: rasterizeProjectAction, setProperty,
    createFromImageData,
    addPageFromImageData, createMarkerFromImageData: updateMarkerFromImageData });
